import { useState } from "react";

const Queries = () => {
  const [selects, setSelects] = useState([0]);
  const [selectOption, setSelectOption] = useState([1]);
  const [conditionOption, setConditionOption] = useState([0]);
  const [conditionOptionValues, setConditionOptionValues] = useState([0]);
  const [conditions, setConditions] = useState([0]);
  const [count, setCount] = useState([0]);
  const [selectValues, setSelectValues] = useState([null]); // Stores values for each select
  const [countValues, setCountValues] = useState([null]); // Stores values for count selects
  const [selectOptionValues, setSelectOptionValues] = useState([null]); // Stores values for condition selects
  const [conditionValues, setConditionValues] = useState([null]); // Stores values for condition selects
  const [countOption, setCountOption] = useState([
    { id: 0, selectValue: "", columnName: "" },
  ]);
  const [countOptionIdCounter, setCountOptionIdCounter] = useState(1);

  const [orValues, setOrValues] = useState([null]);
  const [orConditionValues, setOrConditionValues] = useState([null]);

  // Update select value
  const handleSelectChange = (index, value) => {
    const updatedValues = [...selectValues];
    updatedValues[index] = value;
    setSelectValues(updatedValues);
  };

  const handleCountChange = (index, value) => {
    const updated = [...countOption];
    updated[index].selectValue = value;
    setCountOption(updated);
  };

  const handleCountInputChange = (index, value) => {
    const updated = [...countOption];
    updated[index].columnName = value;
    setCountOption(updated);
  };

  // Update condition value
  const handleConditionChange = (index, value) => {
    const updatedValues = [...conditionValues];
    updatedValues[index] = value;
    setConditionValues(updatedValues);
  };

  const handleOrChange = (index, value) => {
    const updatedValues = [...conditionValues];
    updatedValues[index] = value;
    setOrValues(updatedValues);
  };

  const handleOrConditionChange = (index, value) => {
    const updatedValues = [...conditionValues];
    updatedValues[index] = value;
    setOrConditionValues(updatedValues);
  };

  // Update condition value
  const handleConditionOptionChange = (index, value) => {
    const updatedValues = [...conditionOptionValues];
    updatedValues[index] = value;
    setConditionOptionValues(updatedValues);
  };

  const addSelect = () => {
    if (selects.length === 0) {
      setSelects((prev) => [...prev, prev.length]);
      setSelectValues((prev) => [...prev, null]);
    }
  };

  const removeSelects = (idToRemove) => {
    setSelects((prev) => prev.filter((id) => id !== idToRemove));
    setSelectValues((prev) => prev.filter((_, index) => index !== idToRemove));
  };

  const addCount = () => {
    if (count.length === 0) {
      setCount((prev) => [...prev, prev.length]);
      setCountValues((prev) => [...prev, null]);
    }
  };

  const addCountOption = () => {
    setCountOption((prev) => [
      ...prev,
      { id: countOptionIdCounter, selectValue: "", columnName: "" },
    ]);
    setCountOptionIdCounter((prev) => prev + 1);
  };

  const removeCountOption = (idToRemove) => {
    setCountOption((prev) => prev.filter((item) => item.id !== idToRemove));
  };

  const addConditions = () => {
    if (conditions.length === 0) {
      setConditions((prev) => [...prev, prev.length]);
      setConditionValues((prev) => [...prev, null]);
    }
  };

  const removeConditions = (idToRemove) => {
    setConditions((prev) => prev.filter((id) => id !== idToRemove));
  };

  const removeCount = (idToRemove) => {
    setCount((prev) => prev.filter((id) => id !== idToRemove));
    setCountValues((prev) => prev.filter((_, index) => index !== idToRemove));
  };

  const addSelectOption = () => {
    setSelectOption((prev) => [...prev, prev.length]);
    setSelectOptionValues((prev) => [...prev, null]);
  };

  const addConditionOptions = () => {
    setConditionOption((prev) => [...prev, prev.length]);
    setConditionValues((prev) => [...prev, null]);
  };

  const removeConditionOptions = (idToRemove) => {
    setConditionOption((prev) => prev.filter((id) => id !== idToRemove));
    setConditionValues((prev) =>
      prev.filter((_, index) => index !== idToRemove)
    );
  };

  const removeSelectOption = (idToRemove) => {
    setSelectOption((prev) => prev.filter((id) => id !== idToRemove));
  };

  const ColumnDropdown = ({ values, handleChange, index }) => {
    return (
      <select
        value={values[index] || ""}
        onChange={(e) => handleChange(index, e.target.value)}
      >
        <option value="all">All</option>
        <option value="first_name">First Name</option>
        <option value="middle_name">Middle Name</option>
        <option value="last_name">Last Name</option>
        <option value="ethnicity">Ethnicity</option>
      </select>
    );
  };

  const MatchDropdown = ({ values, handleChange, index }) => {
    return (
      <select
        value={values[index] || ""}
        onChange={(e) => handleChange(index, e.target.value)}
      >
        <option value="is">is</option>
        <option value="is_null">is null</option>
        <option value="contains">contains</option>
        <option value="begins">begins with</option>
        <option value="ends">end with</option>
      </select>
    );
  };

  console.log(countOption);

  return (
    <div className="query-page">
      <div className="query-top-buttons">
        <button onClick={addSelect}>Add Select</button>
        <button onClick={addCount}>Add Count</button>
        <button onClick={addConditions}>Add Where</button>
      </div>

      <div className="query-builder">
        {selects.map((id, index) => (
          <div key={index} className="select-container">
            <div className="query-name-and-button-div">
              <span>SELECT</span>

              <button
                className="query-button"
                onClick={() => removeSelects(id)}
              >
                Remove
              </button>
            </div>

            {selectOption.map((id, index) => (
              <div key={id} className="select-options-container">
                <ColumnDropdown
                  values={selectValues}
                  handleChange={handleSelectChange}
                  index={index}
                />
                <button
                  className="dynamic-query-button"
                  onClick={() => removeSelectOption(id)}
                >
                  Remove
                </button>
              </div>
            ))}
            <button  className="add-other" onClick={addSelectOption}>Add Another Select</button>
          </div>
        ))}

        {count.map((id, index) => (
          <div key={index} className="select-container">
            <div className="query-name-and-button-div">
            <p>COUNT</p>
            <button className="query-button" onClick={() => removeCount(id)}>Remove</button>
            </div>

            {countOption.map((item, index) => (
              <div key={item.id} className="select-options-container">
                <select
                  value={item.selectValue}
                  onChange={(e) => handleCountChange(index, e.target.value)}
                >
                  <option value="first_name">First Name</option>
                  <option value="middle_name">Middle Name</option>
                  <option value="last_name">Last Name</option>
                  <option value="ethnicity">Ethnicity</option>
                </select>
                <span>as</span>
                <input
                  value={item.columnName}
                  onChange={(e) =>
                    handleCountInputChange(index, e.target.value)
                  }
                  placeholder={countOption[index].selectValue}
                />
                <button
                  className="dynamic-query-button"
                  onClick={() => removeCountOption(item.id, index)}
                >
                  Remove
                </button>
              </div>
            ))}

            <button  className="add-other" onClick={addCountOption}>Add Another Count</button>
          </div>
        ))}

        {conditions.map((id, index) => (
          <div className="select-container">
            <div className="query-name-and-button-div">
            <p>WHERE</p>
            <button className="query-button" onClick={() => removeConditions(id)}>Remove</button>
            </div>

            {conditionOption.map((id, index) => (
              <div key={id} className="select-options-container">
                <ColumnDropdown
                  values={conditionValues}
                  handleChange={handleConditionChange}
                  index={index}
                />

                <MatchDropdown
                  values={conditionOptionValues}
                  handleChange={handleConditionOptionChange}
                  index={index}
                />

                <input></input>

                <span>or</span>

                <ColumnDropdown
                  values={orValues}
                  handleChange={handleOrChange}
                  index={index}
                />

                <MatchDropdown
                  values={orConditionValues}
                  handleChange={handleOrConditionChange}
                  index={index}
                />

                <input></input>

                <button
                  className="dynamic-query-button"
                  onClick={() => removeConditionOptions(id)}
                >
                  Remove
                </button>
              </div>
            ))}
            <button className="add-other" onClick={addConditionOptions}>Add Another Condition</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Queries;
